import React, { useContext } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { IUseApiProps } from '../useApi';
import ClReportCls from './ClReportCls';
import { OrbUserContext } from '../OrbUserContext';


export interface IClReportProps extends IUseApiProps, IWithErrorHandlingProps {
}

const ClReport = (props: IClReportProps) => {
    const { userPermissions } = useContext(OrbUserContext);
    return (
        <ErrorBoundary>
            <ClReportCls
                userPermissions={userPermissions}
                {...props}
            />
        </ErrorBoundary>
    );
};

export default withErrorHandling(ClReport);
